import { Route, Routes } from "react-router-dom";
import { OSCI0104015Q } from "../ptl/role/OSCI0104015Q";
import { OSCI0104016S } from "../ptl/role/OSCI0104016S";
import { OSCI0104017S } from "../ptl/role/OSCI0104017S";
import { OSCI0104010Q } from "../ptl/auth/OSCI0104010Q";
import { OSCI0104011S } from "../ptl/auth/OSCI0104011S";
import { OSCI0104012S } from "../ptl/auth/OSCI0104012S";
import { OSCI0104001Q } from "../ptl/menu/OSCI0104001Q";
import { OSCI0104002S } from "../ptl/menu/OSCI0104002S";
import { OSCI0104003S } from "../ptl/menu/OSCI0104003S";
import { OSCI0104004Q } from "../ptl/scrn/OSCI0104004Q";
import { OSCI0104005S } from "../ptl/scrn/OSCI0104005S";
import { OSCI0104006S } from "../ptl/scrn/OSCI0104006S";
import { OSCI0104007Q } from "../ptl/menuscrn/OSCI0104007Q";
import { OSCI0104008S } from "../ptl/menuscrn/OSCI0104008S";
import { OSCI0111004Q } from "../sysm/lbl/OSCI0111004Q";
import { OSCI0111005S } from "../sysm/lbl/OSCI0111005S";
import { OSCI0111006S } from "../sysm/lbl/OSCI0111006S";
import { OSCI0111013Q } from "../sysm/bltbrd/OSCI0111013Q";
import { OSCI0111014S } from "../sysm/bltbrd/OSCI0111014S";
import { OSCI0111015S } from "../sysm/bltbrd/OSCI0111015S";
import { OSCI0111016Q } from "../sysm/bltbrd/OSCI0111016Q";
import { OSCI0111017Q } from "../sysm/bltbrd/OSCI0111017Q";
import { OSCI0106001Q } from "../cmnty/btbdms/OSCI0106001Q";
import { OSCI0106002Q } from "../cmnty/btbdms/OSCI0106002Q";
import { OSCI0106003S } from "../cmnty/btbdms/OSCI0106003S";
import { OSCI0106004S } from "../cmnty/btbdms/OSCI0106004S";
import { OSCI0104020Q } from "../ptl/usrauth/OSCI0104020Q";
import { OSCI0104021S } from "../ptl/usrauth/OSCI0104021S";
import { OSCI0107001Q } from "../clntsport/manl/OSCI0107001Q";
import { OSCI0107002S } from "../clntsport/manl/OSCI0107002S";
import { OSCI0107003S } from "../clntsport/manl/OSCI0107003S";
import { OSCI0111007Q } from "../sysm/msg/OSCI0111007Q";
import { OSCI0111009S } from "../sysm/msg/OSCI0111009S";
import { OSCI0111008Q } from "../sysm/msg/OSCI0111008Q";
import { OSCI0111010S } from "../sysm/msg/OSCI0111010S";
import { OSCI0107004Q } from "../clntsport/manl/OSCI0107004Q";
import { OSCI0104025Q } from "../ptl/role/OSCI0104025Q";
import { OSCI0104026S } from "../ptl/role/OSCI0104026S";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 * TODO URL의 'key' 를 실제 ID로 변경 하세요.
 * TODO 위의 한글 주석은 마지막에 전부 삭제하세요.
 */
export const PtlRouter = () => {
    return (
        <Routes>
            {/** ==================== Role Management Router START ==================== */}
            {/** aaaaaa **/}
            {/* Role Management List !== 역할 관리 목록 ==! */}
            <Route path={"/role/osci0104015q"} element={<OSCI0104015Q />} />
            {/* Role Management Registration !== 역할 관리 등록 ==! */}
            <Route path={"/role/osci0104016s"} element={<OSCI0104016S />} />
            {/* Role Management Details !== 역할 관리 상세 ==! */}
            <Route path={"/role/osci0104017s/:roleId"} element={<OSCI0104017S />} />
            {/** ==================== Role Management Router END ==================== */}

            {/** ==================== Auth Management Router START ==================== */}

            {/* Auth Management List !== 권한 관리 목록 ==! */}
            <Route path={"/auth/osci0104010q"} element={<OSCI0104010Q />} />
            {/* Auth Management Registration !== 권한 관리 등록 ==! */}
            <Route path={"/auth/osci0104011s"} element={<OSCI0104011S />} />
            {/* Auth Management Details !== 권한 관리 상세 ==! */}
            <Route path={"/auth/osci0104012s/:authId"} element={<OSCI0104012S />} />

            {/** ==================== Auth Management Router END ==================== */}

            {/** ==================== Menu Management Router START ==================== */}

            {/* Select. Menu List !== 메뉴 목록 조회 ==! */}
            <Route path={"/menu/osci0104001q"} element={<OSCI0104001Q />} />
            {/* Create. Menu Info !== 메뉴 정보 생성 ==! */}
            <Route path={"/menu/osci0104002s/:uprMenuId?"} element={<OSCI0104002S />} />
            {/* Save. Menu Info !== 메뉴 정보 저장 ==! */}
            <Route path={"/menu/osci0104003s/:menuId"} element={<OSCI0104003S />} />

            {/** ==================== Menu Management Router END ==================== */}

            {/** ==================== Screen Management Router START ==================== */}

            {/* Select. Screen List !== 화면 목록 조회 ==! */}
            <Route path={"/scrn/osci0104004q"} element={<OSCI0104004Q />} />
            {/* Create. Screen Info !== 화면 정보 생성 ==! */}
            <Route path={"/scrn/osci0104005s"} element={<OSCI0104005S />} />
            {/* Save. Screen Info !== 화면 정보 저장 ==! */}
            <Route path={"/scrn/osci0104006s/:scrnId"} element={<OSCI0104006S />} />

            {/** ==================== Screen Management Router END ==================== */}

            {/** ==================== Menu Screen Management Router START ==================== */}

            {/* Menu and Screen List !== 메뉴화면 연결 목록 ==! */}
            <Route path={"/menu-scrn/osci0104007q"} element={<OSCI0104007Q />} />
            {/* Menu and Screen Detail !== 메뉴화면 연결 상세 ==! */}
            <Route path={"/menu-scrn/osci0104008s/:menuId"} element={<OSCI0104008S />} />

            {/** ==================== Menu Screen Management Router END ==================== */}

            {/** ==================== Label Language Router START ==================== */}

            {/* Label Language List !== 라벨 언어 목록 ==! */}
            <Route path={"/lbl/osci0111004q"} element={<OSCI0111004Q />} />

            {/* Label Language Registration !== 라벨 언어 등록 ==! */}
            <Route path={"/lbl/osci0111005s"} element={<OSCI0111005S />} />

            {/* Label Language Change !== 라벨 언어 수정 ==! */}
            <Route path={"/lbl/osci0111006s/:lblId"} element={<OSCI0111006S />} />

            {/** ==================== Label Language Router END ==================== */}

            {/** ==================== Bulletin board Management Router START ==================== */}

            {/** Bulletin board Management List !== 게시판 관리 목록 ==! */}
            <Route path={"/bltbrd/osci0111013q"} element={<OSCI0111013Q />} />

            {/** Bulletin board Management Registration !== 게시판 관리 등록 ==! */}
            <Route path={"/bltbrd/osci0111014s"} element={<OSCI0111014S />} />

            {/** Bulletin board Management Change !== 게시판 관리 수정 ==! */}
            <Route path={"/bltbrd/osci0111015s/:bltbrdId"} element={<OSCI0111015S />} />

            {/** Bulletin board Type Code Popup !== 게시판 유형코드 팝업 ==! */}
            <Route path={"/bltbrd/osci0111016q"} element={<OSCI0111016Q />} />

            {/** Bulletin board Popup !== 게시판 팝업 ==! */}
            <Route path={"/bltbrd/osci0111017q"} element={<OSCI0111017Q />} />
            {/** ====================  Bulletin board Management Router END ==================== */}

            {/** ==================== common Bulletin board Router START ==================== */}

            {/* Common Bulletin board(Bulletin board message) List !== 공통 게시판 (게시글) 목록 ==! */}
            <Route path={"/btbdms/osci0106001q"} element={<OSCI0106001Q />} />

            {/* Common Bulletin Board(Bulletin board message) Detail !== 공통 게시판(게시글) 상세 ==! */}
            <Route path={"/btbdms/osci0106002q/:bltbrdId/:btbdmsId"} element={<OSCI0106002Q />} />

            {/* Common Bulletin Board(Bulletin board message) Registration !== 공통 게시판(게시글) 등록 ==! */}
            <Route path={"/btbdms/osci0106003s/:bltbrdId"} element={<OSCI0106003S />} />

            {/* Common Bulletin Board(Bulletin board message) Modification !== 공통 게시판(게시글) 수정 ==! */}
            <Route path={"/btbdms/osci0106004s/:bltbrdId/:btbdmsId"} element={<OSCI0106004S />} />

            {/** ====================  common bltbrd Router END ==================== */}

            {/** ==================== OGA User Auth Router START ==================== */}

            {/* OGA User Auth List !== 기관 사용자 권한 목록 ==! */}
            <Route path={"/org-auth/osci0104020q"} element={<OSCI0104020Q />} />
            {/* OGA User Auth Registration !== 기관 사용자 권한 등록 ==! */}
            <Route path={"/org-auth/osci0104021s/:tin"} element={<OSCI0104021S />} />

            {/** ==================== OGA User Auth Router END ==================== */}

            <Route path="/org-role/osci0104025q" element={<OSCI0104025Q />} />
            <Route path="/org-role/osci0104026s/:usrIdntfId" element={<OSCI0104026S />} />

            {/** ==================== 메뉴얼 목록조회 ==================== */}
            <Route path="/manl/osci0107001q" element={<OSCI0107001Q />} />
            <Route path="/manl/osci0107002s" element={<OSCI0107002S />} />
            <Route path="/manl/osci0107003s/:scrnId" element={<OSCI0107003S />} />
            <Route path="/manl/osci0107004q" element={<OSCI0107004Q />} />

            {/** ==================== 메시지 언어 관리 ==================== */}
            <Route path="/msg/osci0111007q" element={<OSCI0111007Q />} />
            <Route path="/msg/osci0111009s" element={<OSCI0111009S />} />
            <Route path="/msg/osci0111008q/:msgId" element={<OSCI0111008Q />} />
            <Route path="/msg/osci0111010s/:msgId" element={<OSCI0111010S />} />
        </Routes>
    );
};
